function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.8489 16.0822H26.2396C25.7084 11.0379 21.4531 7.09038 16.2792 7.04945V6.43097C17.3787 6.04245 18.1505 5.16888 18.1505 4.15393C18.1505 2.78083 16.7391 1.66016 15.0079 1.66016C13.2753 1.66016 11.8652 2.77687 11.8652 4.15393C11.8652 5.16888 12.633 6.04109 13.7365 6.43097V7.04945C8.55347 7.09306 4.28729 11.0592 3.77339 16.1194H3.19189C2.47824 16.1194 1.89941 16.6982 1.89941 17.4119V21.1374C1.89941 21.8511 2.47824 22.4299 3.19189 22.4299H3.73637C3.88835 24.5074 5.47553 26.0086 8.47282 26.8994C8.52039 26.91 11.5824 27.6567 15.4283 27.6567C17.367 27.6567 19.508 27.4677 21.5616 26.8994C24.4809 26.0906 26.1462 24.4968 26.2913 22.3967H26.8569C27.5706 22.3967 28.1494 21.8179 28.1494 21.1043V17.3787C28.1494 16.6651 27.5706 16.0862 26.8569 16.0862L26.8489 16.0822ZM12.3726 4.14973C12.3726 3.05416 13.5528 2.16344 15.0078 2.16344C16.4628 2.16344 17.643 3.05284 17.643 4.14973C17.643 5.2453 16.4589 6.13603 15.0078 6.13603C13.5567 6.13603 12.3726 5.24662 12.3726 4.14973ZM15.0078 6.64218C15.2721 6.64218 15.5285 6.61179 15.7756 6.56421V7.04526H14.2426V6.56421C14.4897 6.61443 14.7435 6.64218 15.0104 6.64218H15.0078ZM2.40276 21.133V17.4074C2.40276 16.974 2.75431 16.6224 3.18776 16.6224H3.72961C3.71904 16.7956 3.71639 16.9674 3.71639 17.1431V21.9141H3.18909C2.75564 21.9141 2.40409 21.5625 2.40409 21.1291L2.40276 21.133ZM25.7903 22.0898C25.7903 24.6509 23.4115 25.8481 21.4186 26.4033C15.4266 28.0645 8.65757 26.4165 8.59938 26.4033C5.69726 25.5403 4.22494 24.0893 4.22494 22.0898V17.1473C4.22494 11.8557 8.52799 7.55297 13.8193 7.55297H16.1981C21.4897 7.55297 25.7924 11.856 25.7924 17.1473V22.0898H25.7903ZM27.6339 21.0986C27.6339 21.5321 27.2823 21.8836 26.8489 21.8836H26.2978V17.1472C26.2978 16.9608 26.2912 16.7745 26.2806 16.5895H26.8489C27.2823 16.5895 27.6339 16.941 27.6339 17.3745V21.1L27.6339 21.0986Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 1.5625
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0943 17.5392C11.6283 17.5392 12.0617 16.6723 12.0617 15.6071C12.0617 14.5407 11.6283 13.675 11.0943 13.675C10.5604 13.675 10.127 14.542 10.127 15.6071C10.127 16.6736 10.5604 17.5392 11.0943 17.5392Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8716 17.5392C19.4055 17.5392 19.839 16.6723 19.839 15.6071C19.839 14.5407 19.4055 13.675 18.8716 13.675C18.3376 13.675 17.9042 14.542 17.9042 15.6071C17.9042 16.6736 18.3376 17.5392 18.8716 17.5392Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4755 22.5803H16.4702C14.846 24.0446 13.4755 22.5803 13.4755 22.5803Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0943 17.5392C11.6283 17.5392 12.0617 16.6723 12.0617 15.6071C12.0617 14.5407 11.6283 13.675 11.0943 13.675C10.5604 13.675 10.127 14.542 10.127 15.6071C10.127 16.6736 10.5604 17.5392 11.0943 17.5392Z",
  stroke: "currentColor",
  strokeWidth: 1.09375
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8716 17.5392C19.4055 17.5392 19.839 16.6723 19.839 15.6071C19.839 14.5407 19.4055 13.675 18.8716 13.675C18.3376 13.675 17.9042 14.542 17.9042 15.6071C17.9042 16.6736 18.3376 17.5392 18.8716 17.5392Z",
  stroke: "currentColor",
  strokeWidth: 1.09375
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4755 22.5803H16.4702C14.846 24.0446 13.4755 22.5803 13.4755 22.5803Z",
  stroke: "currentColor",
  strokeWidth: 1.09375
});

var SvgRobotSmall = function SvgRobotSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRobotSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/robot_small.37dec86a.svg";
export { ForwardRef as ReactComponent };